// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_3fD","cls2":"ActiveState-cls2_qqG ActiveState-cls1_3fD"};